import * as React from "react";
import "./style_2.scss";
import { Fragment, useEffect, useRef, useState } from "react";

const tolerance = 2;

export default function ProductAccordionContentStyle2({
  infoBlock,
  itemIndex,
}) {
  const [showFullDescription, setShowFullDescription] = useState(false);
  const descriptionRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const urlStringParser = (stringData) => {
    return (stringData || "").replace(
      /\bhttps?:\/\/\S+/gi,
      '<a href="$&" target="_blank" rel="nofollow">$&</a>'
    );
  };

  useEffect(() => {
    const checkOverflow = () => {
      const element = descriptionRef.current;
      if (!element) return;

      const lineHeight = parseFloat(
        window.getComputedStyle(element).lineHeight
      );
      const maxHeight = lineHeight * 5;
      setIsTruncated(element.scrollHeight > maxHeight + tolerance);
    };

    checkOverflow();
    const observer = new ResizeObserver(checkOverflow);
    observer.observe(descriptionRef.current);
    return () => observer.disconnect();
  }, [infoBlock.learn_more]);

  return infoBlock ? (
    <div className={`accordion-content-block style_2 item_${itemIndex}`}>
      {infoBlock.image && <img src={infoBlock.image} alt="" />}
      {infoBlock.title && <h3>{infoBlock.title}</h3>}

      {infoBlock.info_data && infoBlock.info_data.count && (
        <h2>{infoBlock.info_data.count}</h2>
      )}
      {infoBlock.info_data && (
        <h5>
          {infoBlock.info_data.icon && (
            <img
              src={`/static/images/product-passport/${infoBlock.info_data.icon}.svg`}
              alt=""
            />
          )}
          {infoBlock.info_data.unit && <span>{infoBlock.info_data.unit}</span>}
          {infoBlock.info_data.icon && (
            <span>{infoBlock.info_data.element}</span>
          )}
        </h5>
      )}
      {infoBlock.progress_data && (
        <div className={`progress-bar-list`}>
          {infoBlock.progress_data
            .sort((a, b) => b.progress - a.progress)
            .map((progressItem) => (
              <Fragment key={progressItem.title}>
                {!!progressItem.progress &&
                  progressItem.progress > 0 &&
                  progressItem.progress !== "0.0" && (
                    <div className={`progress-item`}>
                      <h4>{progressItem.title}</h4>
                      <div className={`progress-bar-indicator`}>
                        <div className={`progress-bar`}>
                          <div
                            className={`bar`}
                            style={{ width: progressItem.progress + "%" }}
                          ></div>
                        </div>

                        <div className={`progress-label`}>
                          {progressItem.progress}%
                        </div>
                      </div>
                    </div>
                  )}
              </Fragment>
            ))}
        </div>
      )}

      {infoBlock.learn_more && (
        <div className="info-text-wrapper">
          <div
            className={`info-text-content ${
              showFullDescription || !itemIndex ? "expanded" : ""
            }`}
            ref={descriptionRef}
          >
            <p
              dangerouslySetInnerHTML={{
                __html: urlStringParser(infoBlock.learn_more),
              }}
            />
          </div>

          {!!itemIndex && isTruncated && (
            <a
              className={showFullDescription ? "show-less" : ""}
              onClick={() => setShowFullDescription((prev) => !prev)}
            >
              {showFullDescription ? "View Less" : "Read full description"}
            </a>
          )}
        </div>
      )}
    </div>
  ) : null;
}
